import { DEFAULT_VALUES, RUNTIME_DATA_EXAMPLE } from '../constants';

class ApiService {
  constructor() {
    this.baseUrl = DEFAULT_VALUES.SERVER_URL;
  }

  // Authentication
  async login(userIdentity, appId, apiKey) {
    try {
      const response = await fetch(`${this.baseUrl}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': apiKey
        },
        body: JSON.stringify({
          user_identity: userIdentity,
          app_id: appId
        })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Login failed');
      }

      return await response.json();
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  }

  async getAuthStatus(apiKey) {
    try {
      const response = await fetch(`${this.baseUrl}/auth/status`, {
        method: 'GET',
        headers: {
          'X-API-Key': apiKey
        }
      });

      if (!response.ok) {
        throw new Error('Status check failed');
      }

      return await response.json();
    } catch (error) {
      console.error('Status check error:', error);
      throw error;
    }
  }

  // Runtime Data
  async sendRuntimeData(sessionId, runtimeData = null) {
    console.log(`🚀 ATTEMPTING TO SEND RUNTIME DATA for session: ${sessionId}`);
    try {
      const data = runtimeData || RUNTIME_DATA_EXAMPLE;
      
      const response = await fetch(`${this.baseUrl}/api/runtime/data/${sessionId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Runtime data send failed');
      }

      return await response.json();
    } catch (error) {
      console.error('Runtime data error:', error);
      throw error;
    }
  }

  // Health Check
  async healthCheck() {
    try {
      const response = await fetch(`${this.baseUrl}/health`);
      if (!response.ok) {
        throw new Error('Health check failed');
      }
      return await response.json();
    } catch (error) {
      console.error('Health check error:', error);
      throw error;
    }
  }
}

export const apiService = new ApiService(); 